export const CLICK_PRICE_TAG = 'CLICK_PRICE_TAG'
export const CLEAR_PRICE_TAG = 'CLEAR_PRICE_TAG'
